import { Component, Input } from '@angular/core';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { Avatar } from 'primeng/avatar';
import { BlobImageDirective } from '../../directives/blob.directive';
import { NameToCharactersPipe } from '../../directives/name-to-characters/name-to-characters.pipe';
import { RandomAvatarDirective } from '../../directives/random-value/random-avatar.directive';

@Component({
  selector: 'app-user-avatar',
  templateUrl: './user-avatar.component.html',
  styleUrls: ['./user-avatar.component.scss'],
  imports: [
    Avatar,
    SvgIconComponent,
    BlobImageDirective,
    RandomAvatarDirective,
    NameToCharactersPipe,
  ],
})
export class UserAvatarComponent {
  @Input() avatar?: string | null;
  @Input() displayName = '';
  @Input() isChatbot = false;
}
